<!-- eslint-disable -->
<i18n>
{
  "cl": {
    "linkTextGoBack": "Atrás"
  },
  "pe": {
    "linkTextGoBack": "Atrás"
  },
  "br": {
    "linkTextGoBack": "Atrás"
  }
}
</i18n>
<!-- eslint-enable -->
<template>
  <div class="internal">
    <div class="gradient-header" />
    <Sidebar
      :open-menu="openMenu"
      @hoverChange="handleHovered"
      @openMenu="setOpenMenu"
      @menuLock="handleMenuLocked" />
    <div class="internal-content" :class="isMenuLocked ? 'expanded' : 'reduced'">
      <div class="gradient-header" />
      <Header class="main-header" :open-menu="openMenu" @openMenu="setOpenMenu" />
      <div class="general-content" data-cy="general-content">
        <Notifications />
        <transition :name="transitionName">
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/ui/components/Header.vue';
import Sidebar from '@/ui/layout/internal/Sidebar.vue';
import Notifications from '@/ui/components/internal/Notifications.vue';

export default {
  components: {
    Notifications,
    Header,
    Sidebar
  },
  data() {
    return {
      transitionName: 'rotate-left',
      openMenu: false,
      isHovered: false,
      isMenuLocked: false
    };
  },
  methods: {
    setOpenMenu(openMenu) {
      this.openMenu = openMenu;
    },
    handleHovered(reduce) {
      this.isHovered = reduce;
    },
    handleMenuLocked(isMenuLocked) {
      this.isMenuLocked = isMenuLocked;
    }
  }
};
</script>
<style lang="css" scoped>
a {
  -webkit-transition: all 300ms ease-in-out;
  -moz-transition: all 300ms ease-in-out;
  -ms-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
}

.internal-content {
  min-height: 100vh;
  background-color: #f6f6f8;
  padding-top: 45px;
  overflow: hidden;
  position: relative;
  transition: all 0.5s ease;
}
.gradient-header {
  background: linear-gradient(180deg, rgb(246, 246, 248) 50%, rgba(246, 246, 248, 0) 100%);
  height: 120px;
  position: fixed;
  top: 0;
  z-index: 99;
  width: -webkit-fill-available;
}

.main-header {
  width: 90%;
  max-width: 1200px;
        left: 0px;
        margin: auto;
        position: relative;
        height: 50px;
        top: 0;
        z-index: 999;
        display: flex;
    justify-content: flex-end;
}

@media (max-width: 1024px) {
  .internal-content {
    margin-left: 190px;
    width: calc(100% - 190px);
  }
}

@media (max-width: 910px) {
  .internal-content {
    margin-left: 0;
    width: 100%
  }
}

@media (max-width: 640px) {
}

@media only screen and (min-width: 911px){
  .internal-content.reduced{
    width: calc(100% - 80px);
    margin-left: 80px;
  }
  .internal-content.expanded{
    width: calc(100% - 240px);
    margin-left: 240px;
  }
  .main-header.reduced {
    width: calc(100% - 80px);
    margin-left: 580px;
  }
}
</style>
